import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExternalLink = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.2 2.13336C2.6109 2.13336 2.13333 2.61093 2.13333 3.20003V12.8C2.13333 13.3891 2.6109 13.8667 3.2 13.8667H12.8C13.3891 13.8667 13.8667 13.3891 13.8667 12.8V9.0667C13.8667 8.77215 13.6278 8.53336 13.3333 8.53336C13.0388 8.53336 12.8 8.77215 12.8 9.0667V12.8H3.2V3.20003H6.93333C7.22788 3.20003 7.46666 2.96124 7.46666 2.6667C7.46666 2.37215 7.22788 2.13336 6.93333 2.13336H3.2ZM13.7105 2.28958C13.7616 2.34071 13.8002 2.39964 13.8262 2.46255C13.8518 2.5245 13.8662 2.59235 13.8667 2.6635V2.6667V5.8667C13.8667 6.16124 13.6278 6.40003 13.3333 6.40003C13.0388 6.40003 12.8 6.16124 12.8 5.8667V3.95428L7.31045 9.44382C7.10217 9.6521 6.76449 9.6521 6.55621 9.44382C6.34792 9.23554 6.34792 8.89785 6.55621 8.68958L12.0458 3.20003H10.1333C9.83878 3.20003 9.6 2.96124 9.6 2.6667C9.6 2.37215 9.83878 2.13336 10.1333 2.13336H13.3332C13.4055 2.13336 13.4746 2.14775 13.5375 2.17383C13.6004 2.19986 13.6593 2.23844 13.7105 2.28958Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExternalLink)
const IconSvgExternalLink = createIcon(ForwardRef, 'SvgExternalLink')
export default IconSvgExternalLink
